import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _20a25926 = () => interopDefault(import('../../../pages/old/App.vue' /* webpackChunkName: "" */))
const _0aff3318 = () => interopDefault(import('../../../pages/old/home/home.vue' /* webpackChunkName: "" */))
const _adfbd998 = () => interopDefault(import('../../../pages/old/ajkRank/xiaoqu/communityHot.vue' /* webpackChunkName: "" */))
const _70abfb57 = () => interopDefault(import('../../../pages/old/rank/borkerRank/borkerRank.vue' /* webpackChunkName: "" */))
const _54fa11da = () => interopDefault(import('../../../pages/old/rank/storeRank/storeRank.vue' /* webpackChunkName: "" */))
const _04a21344 = () => interopDefault(import('../../../pages/old/ajkRank/qiangshou/index.vue' /* webpackChunkName: "" */))
const _422f0a50 = () => interopDefault(import('../../../pages/old/wakeAPP/wakeAPP.vue' /* webpackChunkName: "" */))
const _9f656858 = () => interopDefault(import('~/layouts/non-available.vue' /* webpackChunkName: "" */))
const _6ee0cbcc = () => interopDefault(import('../../../pages/captcha-wangyi/index.vue' /* webpackChunkName: "" */))
const _f78eb854 = () => interopDefault(import('../../../pages/captcha-geetest/index.vue' /* webpackChunkName: "" */))
const _31500e0c = () => interopDefault(import('../../../pages/trendency/index.vue' /* webpackChunkName: "" */))
const _a25c907e = () => interopDefault(import('../../../pages/old/ajkRank/synList/synList.vue' /* webpackChunkName: "" */))
const _4a08a181 = () => interopDefault(import('../../../pages/esf-package/index.vue' /* webpackChunkName: "" */))
const _ef084da8 = () => interopDefault(import('../../../pages/map/index.vue' /* webpackChunkName: "" */))
const _0678737a = () => interopDefault(import('../../../pages/agreement/carrier/index.vue' /* webpackChunkName: "" */))
const _abcf87c8 = () => interopDefault(import('../../../pages/weak/miniProgram/index.vue' /* webpackChunkName: "" */))
const _3b22ded9 = () => interopDefault(import('../../../pages/common-material/index.vue' /* webpackChunkName: "" */))
const _42a6a67e = () => interopDefault(import('../../../pages/samsung-download/index.vue' /* webpackChunkName: "" */))
const _ca3fe788 = () => interopDefault(import('../../../pages/app/download/index.vue' /* webpackChunkName: "" */))
const _6222cd93 = () => interopDefault(import('~/layouts/error.vue' /* webpackChunkName: "" */))

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/",
    component: _20a25926,
    alias: "/feapp",
    name: "App",
    children: [{
      path: ":city([a-z]+)/",
      component: _0aff3318,
      name: "mHome"
    }, {
      path: "ershou-autorank/xiaoqu",
      component: _adfbd998,
      name: "communityHot"
    }, {
      path: "ershou-autorank/broker",
      component: _70abfb57,
      name: "brokerRank"
    }, {
      path: "ershou-autorank/store",
      component: _54fa11da,
      name: "storeRank"
    }, {
      path: "ershou-autorank/fangyuan/qiangshou/*",
      component: _04a21344,
      name: "qiangshou"
    }, {
      path: "ershou-autorank/fangyuan/pinzhi/*",
      component: _04a21344,
      name: "pinzhi"
    }, {
      path: "ershou-autorank/fangyuan/*",
      component: _04a21344,
      name: "houseRank"
    }, {
      path: "/wake/app",
      component: _422f0a50,
      name: "wakeApp"
    }]
  }, {
    path: "/non-available",
    component: _9f656858,
    name: "Non Available"
  }, {
    path: "/esfcommon-captcha-wy",
    component: _6ee0cbcc,
    name: "captcha"
  }, {
    path: "/esfcommon-captcha-geetest",
    component: _f78eb854,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-wy",
    component: _6ee0cbcc,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-geetest",
    component: _f78eb854,
    name: "captcha"
  }, {
    path: "/:city([a-z]+)/trendency/",
    component: _31500e0c,
    name: "city-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)_:block_id(\\d+)/",
    component: _31500e0c,
    name: "block-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)/",
    component: _31500e0c,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/community/:comm_id",
    component: _31500e0c,
    name: "community-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)-q-:shangquan_id(\\d+)/",
    component: _31500e0c,
    name: "shangquan-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)/",
    component: _31500e0c,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)-q-:shangquan_py(\\w+)/",
    component: _31500e0c,
    name: "shangquan-trendency"
  }, {
    path: "/ershou-autorank/synList",
    component: _a25c907e,
    name: "syn-rankList"
  }, {
    path: "/feapp/ershou-autorank/synList",
    component: _a25c907e,
    name: "syn-rankList-wb"
  }, {
    path: "/ershou-autorank/common",
    component: _4a08a181,
    name: "syn-com"
  }, {
    path: "/:city([a-z]+)/map/community",
    component: _ef084da8,
    name: "map"
  }, {
    path: "/xiaoqu/([a-zA-Z0-9]+)/map/community",
    component: _ef084da8,
    name: "mapwb"
  }, {
    path: "/agreement/carrier/:id",
    component: _0678737a,
    name: "agreement"
  }, {
    path: "/weak/miniProgram/esf",
    component: _abcf87c8,
    name: "weakMiniProgramESF"
  }, {
    path: "/clbCfg/common/material",
    component: _3b22ded9,
    name: "commonMaterial"
  }, {
    path: "/clb_cfg/menu/materialtemplate/materialtemplate",
    component: _3b22ded9,
    name: "commonMaterialPath"
  }, {
    path: "/agreement/samsungDownload",
    component: _42a6a67e,
    name: "samsungDownload"
  }, {
    path: "/esfcommon/app/download",
    component: _ca3fe788,
    name: "appDownload"
  }, {
    path: "*",
    component: _6222cd93,
    name: "Not Found"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
